import React from "react";

export default function Signal1({
  fill = "black",
  width = "40px",
  height = "40px",
  ...others
}) {
  return (
    <svg 
    width={width}
    height={height}
    viewBox="0 0 700 500" 
    xmlns="http://www.w3.org/2000/svg"
    {...others}>
     <g>
  <path d="m198.05 340.08c-2.3828 0-4.668 0.94922-6.3516 2.6367s-2.625 3.9727-2.6211 6.3555v69.047c-0.003906 2.3828 0.9375 4.6719 2.6211 6.3594s3.9688 2.6367 6.3516 2.6367h55.262c2.3828 0 4.668-0.94922 6.3516-2.6367 1.6797-1.6875 2.625-3.9766 2.6211-6.3594v-69.047c0.003907-2.3828-0.94141-4.668-2.6211-6.3555-1.6836-1.6875-3.9688-2.6367-6.3516-2.6367z" fill={fill}/>
  <path d="m280.93 271.03c-4.9531 0.003906-8.9688 4.0156-8.9727 8.9727v138.12-0.003906c-0.003906 2.3828 0.94141 4.6719 2.6211 6.3594 1.6836 1.6836 3.9688 2.6328 6.3516 2.6367h55.266c2.3828-0.003906 4.6641-0.95312 6.3477-2.6367 1.6836-1.6875 2.6289-3.9766 2.625-6.3594v-138.12 0.003906c-0.003907-4.957-4.0195-8.9688-8.9727-8.9727zm8.9922 17.945h37.297v120.18l-37.297-0.003907z" fill={"#e0e0e0"}/>
  <path d="m363.8 201.96c-4.9531 0.003907-8.9688 4.0195-8.9727 8.9727v207.19-0.003906c-0.003906 2.3828 0.94141 4.6719 2.625 6.3594 1.6797 1.6836 3.9648 2.6328 6.3477 2.6367h55.266c2.3828-0.003906 4.668-0.95312 6.3516-2.6367 1.6797-1.6875 2.625-3.9766 2.6211-6.3594v-207.19 0.003907c-0.003907-4.9531-4.0195-8.9688-8.9727-8.9727zm8.9922 17.965h37.297v189.22h-37.297z" fill={"#e0e0e0"}/>
  <path d="m446.68 132.89c-2.3828 0-4.6641 0.94922-6.3477 2.6367-1.6836 1.6875-2.6289 3.9727-2.625 6.3555v276.24c-0.003906 2.3828 0.94141 4.6719 2.625 6.3594 1.6836 1.6836 3.9648 2.6328 6.3477 2.6367h55.266c2.3828-0.003906 4.668-0.95312 6.3516-2.6367 1.6836-1.6875 2.625-3.9766 2.6211-6.3594v-276.24c0.003906-2.3828-0.9375-4.668-2.6211-6.3555s-3.9688-2.6367-6.3516-2.6367zm8.9922 17.965h37.297v258.29h-37.297z" fill={"#e0e0e0"}/>
 </g>
    </svg>
  );
}
